import MultipleChoiceWithScoreRatioForm from './MultipleChoiceWithScoreRatioForm';

export default MultipleChoiceWithScoreRatioForm;
